<template>
  <div>
    <div>New call {{ phoneNumber }}</div>
    <div class="mt-3">
      <b-button @click="acceptCall" size="sm" variant="success">ACCEPT</b-button>
      <b-button @click="declineCall" size="sm" variant="danger" class="ml-4">DECLINE</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewClientCallToast',
  props: {
    phoneNumber: {
      type: String,
      required: true
    }
  },
  methods: {
    acceptCall () {
      this.$emit('accept-call', { phoneNumber: this.phoneNumber })
    },
    declineCall () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
